__turbopack_context__.v({
  "align-baseline": "flex-module-scss-module__3oZnCW__align-baseline",
  "align-baseline--lg": "flex-module-scss-module__3oZnCW__align-baseline--lg",
  "align-baseline--md": "flex-module-scss-module__3oZnCW__align-baseline--md",
  "align-baseline--sm": "flex-module-scss-module__3oZnCW__align-baseline--sm",
  "align-baseline--tablet": "flex-module-scss-module__3oZnCW__align-baseline--tablet",
  "align-baseline--xl": "flex-module-scss-module__3oZnCW__align-baseline--xl",
  "align-baseline--xs": "flex-module-scss-module__3oZnCW__align-baseline--xs",
  "align-baseline--xxs": "flex-module-scss-module__3oZnCW__align-baseline--xxs",
  "align-center": "flex-module-scss-module__3oZnCW__align-center",
  "align-center--lg": "flex-module-scss-module__3oZnCW__align-center--lg",
  "align-center--md": "flex-module-scss-module__3oZnCW__align-center--md",
  "align-center--sm": "flex-module-scss-module__3oZnCW__align-center--sm",
  "align-center--tablet": "flex-module-scss-module__3oZnCW__align-center--tablet",
  "align-center--xl": "flex-module-scss-module__3oZnCW__align-center--xl",
  "align-center--xs": "flex-module-scss-module__3oZnCW__align-center--xs",
  "align-center--xxs": "flex-module-scss-module__3oZnCW__align-center--xxs",
  "align-flex-end": "flex-module-scss-module__3oZnCW__align-flex-end",
  "align-flex-end--lg": "flex-module-scss-module__3oZnCW__align-flex-end--lg",
  "align-flex-end--md": "flex-module-scss-module__3oZnCW__align-flex-end--md",
  "align-flex-end--sm": "flex-module-scss-module__3oZnCW__align-flex-end--sm",
  "align-flex-end--tablet": "flex-module-scss-module__3oZnCW__align-flex-end--tablet",
  "align-flex-end--xl": "flex-module-scss-module__3oZnCW__align-flex-end--xl",
  "align-flex-end--xs": "flex-module-scss-module__3oZnCW__align-flex-end--xs",
  "align-flex-end--xxs": "flex-module-scss-module__3oZnCW__align-flex-end--xxs",
  "align-flex-start": "flex-module-scss-module__3oZnCW__align-flex-start",
  "align-flex-start--lg": "flex-module-scss-module__3oZnCW__align-flex-start--lg",
  "align-flex-start--md": "flex-module-scss-module__3oZnCW__align-flex-start--md",
  "align-flex-start--sm": "flex-module-scss-module__3oZnCW__align-flex-start--sm",
  "align-flex-start--tablet": "flex-module-scss-module__3oZnCW__align-flex-start--tablet",
  "align-flex-start--xl": "flex-module-scss-module__3oZnCW__align-flex-start--xl",
  "align-flex-start--xs": "flex-module-scss-module__3oZnCW__align-flex-start--xs",
  "align-flex-start--xxs": "flex-module-scss-module__3oZnCW__align-flex-start--xxs",
  "align-stretch": "flex-module-scss-module__3oZnCW__align-stretch",
  "align-stretch--lg": "flex-module-scss-module__3oZnCW__align-stretch--lg",
  "align-stretch--md": "flex-module-scss-module__3oZnCW__align-stretch--md",
  "align-stretch--sm": "flex-module-scss-module__3oZnCW__align-stretch--sm",
  "align-stretch--tablet": "flex-module-scss-module__3oZnCW__align-stretch--tablet",
  "align-stretch--xl": "flex-module-scss-module__3oZnCW__align-stretch--xl",
  "align-stretch--xs": "flex-module-scss-module__3oZnCW__align-stretch--xs",
  "align-stretch--xxs": "flex-module-scss-module__3oZnCW__align-stretch--xxs",
  "column": "flex-module-scss-module__3oZnCW__column",
  "content-center": "flex-module-scss-module__3oZnCW__content-center",
  "content-center--lg": "flex-module-scss-module__3oZnCW__content-center--lg",
  "content-center--md": "flex-module-scss-module__3oZnCW__content-center--md",
  "content-center--sm": "flex-module-scss-module__3oZnCW__content-center--sm",
  "content-center--tablet": "flex-module-scss-module__3oZnCW__content-center--tablet",
  "content-center--xl": "flex-module-scss-module__3oZnCW__content-center--xl",
  "content-center--xs": "flex-module-scss-module__3oZnCW__content-center--xs",
  "content-center--xxs": "flex-module-scss-module__3oZnCW__content-center--xxs",
  "content-flex-end": "flex-module-scss-module__3oZnCW__content-flex-end",
  "content-flex-end--lg": "flex-module-scss-module__3oZnCW__content-flex-end--lg",
  "content-flex-end--md": "flex-module-scss-module__3oZnCW__content-flex-end--md",
  "content-flex-end--sm": "flex-module-scss-module__3oZnCW__content-flex-end--sm",
  "content-flex-end--tablet": "flex-module-scss-module__3oZnCW__content-flex-end--tablet",
  "content-flex-end--xl": "flex-module-scss-module__3oZnCW__content-flex-end--xl",
  "content-flex-end--xs": "flex-module-scss-module__3oZnCW__content-flex-end--xs",
  "content-flex-end--xxs": "flex-module-scss-module__3oZnCW__content-flex-end--xxs",
  "content-flex-start": "flex-module-scss-module__3oZnCW__content-flex-start",
  "content-flex-start--lg": "flex-module-scss-module__3oZnCW__content-flex-start--lg",
  "content-flex-start--md": "flex-module-scss-module__3oZnCW__content-flex-start--md",
  "content-flex-start--sm": "flex-module-scss-module__3oZnCW__content-flex-start--sm",
  "content-flex-start--tablet": "flex-module-scss-module__3oZnCW__content-flex-start--tablet",
  "content-flex-start--xl": "flex-module-scss-module__3oZnCW__content-flex-start--xl",
  "content-flex-start--xs": "flex-module-scss-module__3oZnCW__content-flex-start--xs",
  "content-flex-start--xxs": "flex-module-scss-module__3oZnCW__content-flex-start--xxs",
  "content-space-around": "flex-module-scss-module__3oZnCW__content-space-around",
  "content-space-around--lg": "flex-module-scss-module__3oZnCW__content-space-around--lg",
  "content-space-around--md": "flex-module-scss-module__3oZnCW__content-space-around--md",
  "content-space-around--sm": "flex-module-scss-module__3oZnCW__content-space-around--sm",
  "content-space-around--tablet": "flex-module-scss-module__3oZnCW__content-space-around--tablet",
  "content-space-around--xl": "flex-module-scss-module__3oZnCW__content-space-around--xl",
  "content-space-around--xs": "flex-module-scss-module__3oZnCW__content-space-around--xs",
  "content-space-around--xxs": "flex-module-scss-module__3oZnCW__content-space-around--xxs",
  "content-space-between": "flex-module-scss-module__3oZnCW__content-space-between",
  "content-space-between--lg": "flex-module-scss-module__3oZnCW__content-space-between--lg",
  "content-space-between--md": "flex-module-scss-module__3oZnCW__content-space-between--md",
  "content-space-between--sm": "flex-module-scss-module__3oZnCW__content-space-between--sm",
  "content-space-between--tablet": "flex-module-scss-module__3oZnCW__content-space-between--tablet",
  "content-space-between--xl": "flex-module-scss-module__3oZnCW__content-space-between--xl",
  "content-space-between--xs": "flex-module-scss-module__3oZnCW__content-space-between--xs",
  "content-space-between--xxs": "flex-module-scss-module__3oZnCW__content-space-between--xxs",
  "flex": "flex-module-scss-module__3oZnCW__flex",
  "flex-column": "flex-module-scss-module__3oZnCW__flex-column",
  "flex-column--lg": "flex-module-scss-module__3oZnCW__flex-column--lg",
  "flex-column--md": "flex-module-scss-module__3oZnCW__flex-column--md",
  "flex-column--sm": "flex-module-scss-module__3oZnCW__flex-column--sm",
  "flex-column--tablet": "flex-module-scss-module__3oZnCW__flex-column--tablet",
  "flex-column--xl": "flex-module-scss-module__3oZnCW__flex-column--xl",
  "flex-column--xs": "flex-module-scss-module__3oZnCW__flex-column--xs",
  "flex-column--xxs": "flex-module-scss-module__3oZnCW__flex-column--xxs",
  "flex-reverse": "flex-module-scss-module__3oZnCW__flex-reverse",
  "flex-reverse--lg": "flex-module-scss-module__3oZnCW__flex-reverse--lg",
  "flex-reverse--md": "flex-module-scss-module__3oZnCW__flex-reverse--md",
  "flex-reverse--sm": "flex-module-scss-module__3oZnCW__flex-reverse--sm",
  "flex-reverse--tablet": "flex-module-scss-module__3oZnCW__flex-reverse--tablet",
  "flex-reverse--xl": "flex-module-scss-module__3oZnCW__flex-reverse--xl",
  "flex-reverse--xs": "flex-module-scss-module__3oZnCW__flex-reverse--xs",
  "flex-reverse--xxs": "flex-module-scss-module__3oZnCW__flex-reverse--xxs",
  "flex-row": "flex-module-scss-module__3oZnCW__flex-row",
  "flex-row--lg": "flex-module-scss-module__3oZnCW__flex-row--lg",
  "flex-row--md": "flex-module-scss-module__3oZnCW__flex-row--md",
  "flex-row--sm": "flex-module-scss-module__3oZnCW__flex-row--sm",
  "flex-row--tablet": "flex-module-scss-module__3oZnCW__flex-row--tablet",
  "flex-row--xl": "flex-module-scss-module__3oZnCW__flex-row--xl",
  "flex-row--xs": "flex-module-scss-module__3oZnCW__flex-row--xs",
  "flex-row--xxs": "flex-module-scss-module__3oZnCW__flex-row--xxs",
  "flex-row-reverse": "flex-module-scss-module__3oZnCW__flex-row-reverse",
  "flex-row-reverse--lg": "flex-module-scss-module__3oZnCW__flex-row-reverse--lg",
  "flex-row-reverse--md": "flex-module-scss-module__3oZnCW__flex-row-reverse--md",
  "flex-row-reverse--sm": "flex-module-scss-module__3oZnCW__flex-row-reverse--sm",
  "flex-row-reverse--tablet": "flex-module-scss-module__3oZnCW__flex-row-reverse--tablet",
  "flex-row-reverse--xl": "flex-module-scss-module__3oZnCW__flex-row-reverse--xl",
  "flex-row-reverse--xs": "flex-module-scss-module__3oZnCW__flex-row-reverse--xs",
  "flex-row-reverse--xxs": "flex-module-scss-module__3oZnCW__flex-row-reverse--xxs",
  "justify-center": "flex-module-scss-module__3oZnCW__justify-center",
  "justify-center--lg": "flex-module-scss-module__3oZnCW__justify-center--lg",
  "justify-center--md": "flex-module-scss-module__3oZnCW__justify-center--md",
  "justify-center--sm": "flex-module-scss-module__3oZnCW__justify-center--sm",
  "justify-center--tablet": "flex-module-scss-module__3oZnCW__justify-center--tablet",
  "justify-center--xl": "flex-module-scss-module__3oZnCW__justify-center--xl",
  "justify-center--xs": "flex-module-scss-module__3oZnCW__justify-center--xs",
  "justify-center--xxs": "flex-module-scss-module__3oZnCW__justify-center--xxs",
  "justify-flex-end": "flex-module-scss-module__3oZnCW__justify-flex-end",
  "justify-flex-end--lg": "flex-module-scss-module__3oZnCW__justify-flex-end--lg",
  "justify-flex-end--md": "flex-module-scss-module__3oZnCW__justify-flex-end--md",
  "justify-flex-end--sm": "flex-module-scss-module__3oZnCW__justify-flex-end--sm",
  "justify-flex-end--tablet": "flex-module-scss-module__3oZnCW__justify-flex-end--tablet",
  "justify-flex-end--xl": "flex-module-scss-module__3oZnCW__justify-flex-end--xl",
  "justify-flex-end--xs": "flex-module-scss-module__3oZnCW__justify-flex-end--xs",
  "justify-flex-end--xxs": "flex-module-scss-module__3oZnCW__justify-flex-end--xxs",
  "justify-flex-start": "flex-module-scss-module__3oZnCW__justify-flex-start",
  "justify-flex-start--lg": "flex-module-scss-module__3oZnCW__justify-flex-start--lg",
  "justify-flex-start--md": "flex-module-scss-module__3oZnCW__justify-flex-start--md",
  "justify-flex-start--sm": "flex-module-scss-module__3oZnCW__justify-flex-start--sm",
  "justify-flex-start--tablet": "flex-module-scss-module__3oZnCW__justify-flex-start--tablet",
  "justify-flex-start--xl": "flex-module-scss-module__3oZnCW__justify-flex-start--xl",
  "justify-flex-start--xs": "flex-module-scss-module__3oZnCW__justify-flex-start--xs",
  "justify-flex-start--xxs": "flex-module-scss-module__3oZnCW__justify-flex-start--xxs",
  "justify-space-around": "flex-module-scss-module__3oZnCW__justify-space-around",
  "justify-space-around--lg": "flex-module-scss-module__3oZnCW__justify-space-around--lg",
  "justify-space-around--md": "flex-module-scss-module__3oZnCW__justify-space-around--md",
  "justify-space-around--sm": "flex-module-scss-module__3oZnCW__justify-space-around--sm",
  "justify-space-around--tablet": "flex-module-scss-module__3oZnCW__justify-space-around--tablet",
  "justify-space-around--xl": "flex-module-scss-module__3oZnCW__justify-space-around--xl",
  "justify-space-around--xs": "flex-module-scss-module__3oZnCW__justify-space-around--xs",
  "justify-space-around--xxs": "flex-module-scss-module__3oZnCW__justify-space-around--xxs",
  "justify-space-between": "flex-module-scss-module__3oZnCW__justify-space-between",
  "justify-space-between--lg": "flex-module-scss-module__3oZnCW__justify-space-between--lg",
  "justify-space-between--md": "flex-module-scss-module__3oZnCW__justify-space-between--md",
  "justify-space-between--sm": "flex-module-scss-module__3oZnCW__justify-space-between--sm",
  "justify-space-between--tablet": "flex-module-scss-module__3oZnCW__justify-space-between--tablet",
  "justify-space-between--xl": "flex-module-scss-module__3oZnCW__justify-space-between--xl",
  "justify-space-between--xs": "flex-module-scss-module__3oZnCW__justify-space-between--xs",
  "justify-space-between--xxs": "flex-module-scss-module__3oZnCW__justify-space-between--xxs",
  "justify-space-evenly": "flex-module-scss-module__3oZnCW__justify-space-evenly",
  "justify-space-evenly--lg": "flex-module-scss-module__3oZnCW__justify-space-evenly--lg",
  "justify-space-evenly--md": "flex-module-scss-module__3oZnCW__justify-space-evenly--md",
  "justify-space-evenly--sm": "flex-module-scss-module__3oZnCW__justify-space-evenly--sm",
  "justify-space-evenly--tablet": "flex-module-scss-module__3oZnCW__justify-space-evenly--tablet",
  "justify-space-evenly--xl": "flex-module-scss-module__3oZnCW__justify-space-evenly--xl",
  "justify-space-evenly--xs": "flex-module-scss-module__3oZnCW__justify-space-evenly--xs",
  "justify-space-evenly--xxs": "flex-module-scss-module__3oZnCW__justify-space-evenly--xxs",
  "order-0": "flex-module-scss-module__3oZnCW__order-0",
  "order-0--lg": "flex-module-scss-module__3oZnCW__order-0--lg",
  "order-0--md": "flex-module-scss-module__3oZnCW__order-0--md",
  "order-0--sm": "flex-module-scss-module__3oZnCW__order-0--sm",
  "order-0--tablet": "flex-module-scss-module__3oZnCW__order-0--tablet",
  "order-0--xl": "flex-module-scss-module__3oZnCW__order-0--xl",
  "order-0--xs": "flex-module-scss-module__3oZnCW__order-0--xs",
  "order-0--xxs": "flex-module-scss-module__3oZnCW__order-0--xxs",
  "order-1": "flex-module-scss-module__3oZnCW__order-1",
  "order-1--lg": "flex-module-scss-module__3oZnCW__order-1--lg",
  "order-1--md": "flex-module-scss-module__3oZnCW__order-1--md",
  "order-1--sm": "flex-module-scss-module__3oZnCW__order-1--sm",
  "order-1--tablet": "flex-module-scss-module__3oZnCW__order-1--tablet",
  "order-1--xl": "flex-module-scss-module__3oZnCW__order-1--xl",
  "order-1--xs": "flex-module-scss-module__3oZnCW__order-1--xs",
  "order-1--xxs": "flex-module-scss-module__3oZnCW__order-1--xxs",
  "order-10": "flex-module-scss-module__3oZnCW__order-10",
  "order-10--lg": "flex-module-scss-module__3oZnCW__order-10--lg",
  "order-10--md": "flex-module-scss-module__3oZnCW__order-10--md",
  "order-10--sm": "flex-module-scss-module__3oZnCW__order-10--sm",
  "order-10--tablet": "flex-module-scss-module__3oZnCW__order-10--tablet",
  "order-10--xl": "flex-module-scss-module__3oZnCW__order-10--xl",
  "order-10--xs": "flex-module-scss-module__3oZnCW__order-10--xs",
  "order-10--xxs": "flex-module-scss-module__3oZnCW__order-10--xxs",
  "order-11": "flex-module-scss-module__3oZnCW__order-11",
  "order-11--lg": "flex-module-scss-module__3oZnCW__order-11--lg",
  "order-11--md": "flex-module-scss-module__3oZnCW__order-11--md",
  "order-11--sm": "flex-module-scss-module__3oZnCW__order-11--sm",
  "order-11--tablet": "flex-module-scss-module__3oZnCW__order-11--tablet",
  "order-11--xl": "flex-module-scss-module__3oZnCW__order-11--xl",
  "order-11--xs": "flex-module-scss-module__3oZnCW__order-11--xs",
  "order-11--xxs": "flex-module-scss-module__3oZnCW__order-11--xxs",
  "order-12": "flex-module-scss-module__3oZnCW__order-12",
  "order-12--lg": "flex-module-scss-module__3oZnCW__order-12--lg",
  "order-12--md": "flex-module-scss-module__3oZnCW__order-12--md",
  "order-12--sm": "flex-module-scss-module__3oZnCW__order-12--sm",
  "order-12--tablet": "flex-module-scss-module__3oZnCW__order-12--tablet",
  "order-12--xl": "flex-module-scss-module__3oZnCW__order-12--xl",
  "order-12--xs": "flex-module-scss-module__3oZnCW__order-12--xs",
  "order-12--xxs": "flex-module-scss-module__3oZnCW__order-12--xxs",
  "order-2": "flex-module-scss-module__3oZnCW__order-2",
  "order-2--lg": "flex-module-scss-module__3oZnCW__order-2--lg",
  "order-2--md": "flex-module-scss-module__3oZnCW__order-2--md",
  "order-2--sm": "flex-module-scss-module__3oZnCW__order-2--sm",
  "order-2--tablet": "flex-module-scss-module__3oZnCW__order-2--tablet",
  "order-2--xl": "flex-module-scss-module__3oZnCW__order-2--xl",
  "order-2--xs": "flex-module-scss-module__3oZnCW__order-2--xs",
  "order-2--xxs": "flex-module-scss-module__3oZnCW__order-2--xxs",
  "order-3": "flex-module-scss-module__3oZnCW__order-3",
  "order-3--lg": "flex-module-scss-module__3oZnCW__order-3--lg",
  "order-3--md": "flex-module-scss-module__3oZnCW__order-3--md",
  "order-3--sm": "flex-module-scss-module__3oZnCW__order-3--sm",
  "order-3--tablet": "flex-module-scss-module__3oZnCW__order-3--tablet",
  "order-3--xl": "flex-module-scss-module__3oZnCW__order-3--xl",
  "order-3--xs": "flex-module-scss-module__3oZnCW__order-3--xs",
  "order-3--xxs": "flex-module-scss-module__3oZnCW__order-3--xxs",
  "order-4": "flex-module-scss-module__3oZnCW__order-4",
  "order-4--lg": "flex-module-scss-module__3oZnCW__order-4--lg",
  "order-4--md": "flex-module-scss-module__3oZnCW__order-4--md",
  "order-4--sm": "flex-module-scss-module__3oZnCW__order-4--sm",
  "order-4--tablet": "flex-module-scss-module__3oZnCW__order-4--tablet",
  "order-4--xl": "flex-module-scss-module__3oZnCW__order-4--xl",
  "order-4--xs": "flex-module-scss-module__3oZnCW__order-4--xs",
  "order-4--xxs": "flex-module-scss-module__3oZnCW__order-4--xxs",
  "order-5": "flex-module-scss-module__3oZnCW__order-5",
  "order-5--lg": "flex-module-scss-module__3oZnCW__order-5--lg",
  "order-5--md": "flex-module-scss-module__3oZnCW__order-5--md",
  "order-5--sm": "flex-module-scss-module__3oZnCW__order-5--sm",
  "order-5--tablet": "flex-module-scss-module__3oZnCW__order-5--tablet",
  "order-5--xl": "flex-module-scss-module__3oZnCW__order-5--xl",
  "order-5--xs": "flex-module-scss-module__3oZnCW__order-5--xs",
  "order-5--xxs": "flex-module-scss-module__3oZnCW__order-5--xxs",
  "order-6": "flex-module-scss-module__3oZnCW__order-6",
  "order-6--lg": "flex-module-scss-module__3oZnCW__order-6--lg",
  "order-6--md": "flex-module-scss-module__3oZnCW__order-6--md",
  "order-6--sm": "flex-module-scss-module__3oZnCW__order-6--sm",
  "order-6--tablet": "flex-module-scss-module__3oZnCW__order-6--tablet",
  "order-6--xl": "flex-module-scss-module__3oZnCW__order-6--xl",
  "order-6--xs": "flex-module-scss-module__3oZnCW__order-6--xs",
  "order-6--xxs": "flex-module-scss-module__3oZnCW__order-6--xxs",
  "order-7": "flex-module-scss-module__3oZnCW__order-7",
  "order-7--lg": "flex-module-scss-module__3oZnCW__order-7--lg",
  "order-7--md": "flex-module-scss-module__3oZnCW__order-7--md",
  "order-7--sm": "flex-module-scss-module__3oZnCW__order-7--sm",
  "order-7--tablet": "flex-module-scss-module__3oZnCW__order-7--tablet",
  "order-7--xl": "flex-module-scss-module__3oZnCW__order-7--xl",
  "order-7--xs": "flex-module-scss-module__3oZnCW__order-7--xs",
  "order-7--xxs": "flex-module-scss-module__3oZnCW__order-7--xxs",
  "order-8": "flex-module-scss-module__3oZnCW__order-8",
  "order-8--lg": "flex-module-scss-module__3oZnCW__order-8--lg",
  "order-8--md": "flex-module-scss-module__3oZnCW__order-8--md",
  "order-8--sm": "flex-module-scss-module__3oZnCW__order-8--sm",
  "order-8--tablet": "flex-module-scss-module__3oZnCW__order-8--tablet",
  "order-8--xl": "flex-module-scss-module__3oZnCW__order-8--xl",
  "order-8--xs": "flex-module-scss-module__3oZnCW__order-8--xs",
  "order-8--xxs": "flex-module-scss-module__3oZnCW__order-8--xxs",
  "order-9": "flex-module-scss-module__3oZnCW__order-9",
  "order-9--lg": "flex-module-scss-module__3oZnCW__order-9--lg",
  "order-9--md": "flex-module-scss-module__3oZnCW__order-9--md",
  "order-9--sm": "flex-module-scss-module__3oZnCW__order-9--sm",
  "order-9--tablet": "flex-module-scss-module__3oZnCW__order-9--tablet",
  "order-9--xl": "flex-module-scss-module__3oZnCW__order-9--xl",
  "order-9--xs": "flex-module-scss-module__3oZnCW__order-9--xs",
  "order-9--xxs": "flex-module-scss-module__3oZnCW__order-9--xxs",
  "wrap-nowrap": "flex-module-scss-module__3oZnCW__wrap-nowrap",
  "wrap-nowrap--lg": "flex-module-scss-module__3oZnCW__wrap-nowrap--lg",
  "wrap-nowrap--md": "flex-module-scss-module__3oZnCW__wrap-nowrap--md",
  "wrap-nowrap--sm": "flex-module-scss-module__3oZnCW__wrap-nowrap--sm",
  "wrap-nowrap--tablet": "flex-module-scss-module__3oZnCW__wrap-nowrap--tablet",
  "wrap-nowrap--xl": "flex-module-scss-module__3oZnCW__wrap-nowrap--xl",
  "wrap-nowrap--xs": "flex-module-scss-module__3oZnCW__wrap-nowrap--xs",
  "wrap-nowrap--xxs": "flex-module-scss-module__3oZnCW__wrap-nowrap--xxs",
  "wrap-wrap": "flex-module-scss-module__3oZnCW__wrap-wrap",
  "wrap-wrap--lg": "flex-module-scss-module__3oZnCW__wrap-wrap--lg",
  "wrap-wrap--md": "flex-module-scss-module__3oZnCW__wrap-wrap--md",
  "wrap-wrap--sm": "flex-module-scss-module__3oZnCW__wrap-wrap--sm",
  "wrap-wrap--tablet": "flex-module-scss-module__3oZnCW__wrap-wrap--tablet",
  "wrap-wrap--xl": "flex-module-scss-module__3oZnCW__wrap-wrap--xl",
  "wrap-wrap--xs": "flex-module-scss-module__3oZnCW__wrap-wrap--xs",
  "wrap-wrap--xxs": "flex-module-scss-module__3oZnCW__wrap-wrap--xxs",
  "wrap-wrap-reverse": "flex-module-scss-module__3oZnCW__wrap-wrap-reverse",
  "wrap-wrap-reverse--lg": "flex-module-scss-module__3oZnCW__wrap-wrap-reverse--lg",
  "wrap-wrap-reverse--md": "flex-module-scss-module__3oZnCW__wrap-wrap-reverse--md",
  "wrap-wrap-reverse--sm": "flex-module-scss-module__3oZnCW__wrap-wrap-reverse--sm",
  "wrap-wrap-reverse--tablet": "flex-module-scss-module__3oZnCW__wrap-wrap-reverse--tablet",
  "wrap-wrap-reverse--xl": "flex-module-scss-module__3oZnCW__wrap-wrap-reverse--xl",
  "wrap-wrap-reverse--xs": "flex-module-scss-module__3oZnCW__wrap-wrap-reverse--xs",
  "wrap-wrap-reverse--xxs": "flex-module-scss-module__3oZnCW__wrap-wrap-reverse--xxs",
});
